<template>
	<vx-card class="no-scroll-content">
		<h1><strong>{{ $t('phone') }}</strong>: +{{ infoChat.wUser.phone }}
		</h1>
		<br>
		<h5><strong>{{ $t('whatsappNameChannel') }}</strong>: {{ infoChat.channel.name }}</h5>
		<br>
		<template v-if="['admin'].includes($store.state.auth.role)">
			<!-- <hr> -->
			<v-select
				:clearable="false"
				v-model="selectedManagerForOrder"
				class="single-row-select frsSelect"
				label="full_name"
				:options="listManager"
				:items="listManager"
				:placeholder="$t('chooseManager')"
				@input="onChangeSelectedManagerForOrder"
			>      
				<template slot="selected-option" slot-scope="option">
					<span class="frsSelectSpanManager">
						<img :src="option.photo" />
						{{ option.full_name }}&nbsp; 
						<span>
							<feather-icon icon="ClipboardIcon"></feather-icon>:&nbsp; 
							<strong>{{ option.count_active_order }}</strong>
						</span>
					</span>
				</template>
				<template #option="option">
					<span class="frsSelectSpanManager">
						<img :src="option.photo" />
						{{ option.full_name }}&nbsp; 
						<span class="frsSelectSpanColorManager">
							<feather-icon icon="ClipboardIcon"></feather-icon>:&nbsp; 
							<strong>{{ option.count_active_order }}</strong>
						</span>
					</span>
				</template>
			</v-select>
			<!-- <hr> -->
		</template>
		<div class="clientInfo">

		</div>
		<ModalAddNewManagerChatWhatsApp
			v-if="idChat"
			:active.sync="addNewManagerActive"
			@accept="sendAddNewManager"
		/>
	</vx-card>
</template>

<script>
import VxCard from '@/components/vx-card/VxCard'
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";
import vSelect from "vue-select";
import ModalAddNewManagerChatWhatsApp from "@/components/dialogs/ModalAddNewManagerChatWhatsApp";

// import moment from 'moment';
// import date from "@/assets/configs/date.js";

export default {
	mixins: [databaseManager, notifier],
	name: 'InfoChatWazzupSection',
	components: {
        VxCard,
		vSelect,
		ModalAddNewManagerChatWhatsApp,
	},
	props: {

    },
	data () {
		return {
			infoChat: [],
			idChat: null,
			listManager: [],
			selectedManagerForOrder: null,
			addNewManagerActive: false,
			manager: null,

		}
	},
	watch: {
		addNewManagerActive() {
			if(this.addNewManagerActive == false) {
				this.getListManager(this.manager);
			}
		},
	},
	computed: {
		// compColorSpanManager() {
		// 	let cl = 'frsSelectSpanColorManager';
		// 	if(this.manager !== null && this.manager.id !== undefined) {
		// 		return cl + ' frsColorGreenSpan';
		// 	} else {
		// 		return cl + ' frsColorRedSpan';
		// 	}
		// },
	},
	methods: {
		async sendAddNewManager() {
			const rez = await this.dbChangeManagerInChatWhatsApp(this.idChat, this.selectedManagerForOrder.id);
			this.infoChat['manager'] = this.selectedManagerForOrder;
			this.getListManager();
			// this.model = await this.viewOrder();
			// await this.openNewChat(this.chat);
		},
		onChangeSelectedManagerForOrder() {
			this.addNewManagerActive = true;
		},
		async getListManager() {
			this.listManager = await this.dbGetListMangers();

			if(this.infoChat['manager'] !== null && this.infoChat['manager'].id !== undefined) {
				let manID = this.infoChat['manager'];
				let manFind = null;

				this.listManager.forEach(function(elem) {
					if(elem.id == manID.id) {
						manFind = elem;
						return;
					}
				});
				this.selectedManagerForOrder = manFind;
			} else {
				this.selectedManagerForOrder = this.$t('noManagerWhatsAppChat');
			}
		},
		async viewInfoChatWhatsapp() {
			return await this.dbviewInfoChatWhatsapp(this.idChat);
		},

	},
	async created() {
		this.idChat = this.$route.params.id;
		this.infoChat = await this.viewInfoChatWhatsapp();

		const role = this.$store.state.auth.role;
		if(role === 'admin') await this.getListManager();
    }
}
</script>

<style lang="scss" scoped>
	.clientInfo {
		padding: 10px 0px;
	}
    .frsSelectSpanManager {
        display: flex;
        line-height: 28px;
        font-size: small;
        color: black;
    
        img {
            width: 28px;
            margin-right: 10px;
        }	

    }
    .frsSelectSpanColorManager {
        display: flex;
        line-height: 28px;
        font-size: small;
    }
    .align-center {
	    align-items: center;
    }
    .mini-img {
        width: 30px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        border-radius: 100%;
    }
	.counter {
		float: right;
		display: inline-block;
		padding: 5px;
		border-radius: 100%;
		font-weight: 600;
		width: 20px;
		height: 20px;
		font-size: 0.7rem;
		border: 1px solid #cfcfcf;
		display: flex;
		align-items: center;
		justify-content: center;
		line-height: 1;

		&.danger {
			background-color: red;
			color: white;
			border-color: #f0ad4e;
		}
	}

	.vx-card {
		overflow-y: auto;
    	overflow-x: hidden;
		min-height: 400px;

		::v-deep .vx-card__collapsible-content.vs-con-loading__container {
			height: 100%;

			.vx-card__body {
				height: 100%;
			}
		}
	}

	.no-scroll-content {
		height: calc(var(--vh, 1vh)* 100 - 10rem) !important;
	}

	.whatsapp-section {
		overflow-y: auto;
	}

	.whatsapp-section-header {
		padding-bottom: 10px;
	}

	.whatsapp-section-row {
		margin-bottom: 10px;
		cursor: pointer;
	}

</style>
